import React from 'react';

/**
 * Wraps a child tree and catches runtime errors so a crash in one component
 * doesn't blank out the entire app. Useful for the heavy Sidebar tree where
 * a single bad render can otherwise unmount the whole canvas.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface to console; don't break user session.
    console.error('[ErrorBoundary] caught:', error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="p-4 m-2 border-2 border-red-500 bg-red-950/30 text-red-200 text-xs">
          <div className="font-bold mb-1">Sidebar hit an error.</div>
          <div className="opacity-70 mb-2 break-words">
            {String(this.state.error?.message || this.state.error)}
          </div>
          <button
            onClick={this.reset}
            className="px-2 py-1 bg-red-500 text-white font-bold text-xs rounded hover:bg-red-400"
          >
            Recover
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
